import { render, staticRenderFns } from "./BotaoPreAnalise.vue?vue&type=template&id=ca2dec30&lang=pug"
import script from "./BotaoPreAnalise.vue?vue&type=script&lang=js"
export * from "./BotaoPreAnalise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports